a.s.pickerelement = (function(){
	var my = {
		insert:function(s){
			var el = s.el || undefined;
			var type = s.type || undefined;
			var inputname = s.inputname || type;
			var value = s.value || undefined;
			var id = s.id || undefined;
			var cb_select = s.onselect || function(){};
			var cb_reset = s.onreset || function(){};
			var undefined_text = s.undefined_text || 'Not selected';
			var allowtypelist = ["type","user","location"];
			if (allowtypelist.includes(type)) {
				tpl.run({tpl:'/tpl/shared/pickerelement/main.ejs?v='+v,data:{
					type:type,
					inputname:inputname,
					undefined_text:undefined_text,
					value:value,
					id:id
				},cb:function(content){
					el.empty().append(content).ready(function(){
						my.init(el,type,inputname,undefined_text,cb_select,cb_reset);
					});
				}});
			}
			else {
				// Unknown picker type
			}
		},
		init:function(el,type,inputname,undefined_text,cb_select,cb_reset){
			var inp = $('input[name="'+inputname+'"]',el);
			var cc = $('span[data-area="content"]',el);
			var select = $('*[data-action="select"]',el);
			var reset = $('*[data-action="reset"]',el);
			var value = '';
			var content = '';
			// Select
			select.unbind('click').click(function(){
				a.s[type+'picker'].pick(function(result){
					if (result && type=='type') {
						value = result.value;
						content = result.content;
					}
					else if (result && type=='user') {
						value = result.uid;
						content = result.firstname+' '+result.lastname;
					}
					else if (result && type=='location') {
						value = result.id;
						content = result.name;
					}
					cc.removeClass('notdefined').empty().append(content);
					inp.val(value);
					cb_select();
				},{});
				event.preventDefault();
			});
			reset.unbind('click').click(function(){
				cc.addClass('notdefined').empty().append(undefined_text);
				inp.val('');
				cb_reset();
				event.preventDefault();
				return false;
			});
		}
	}
	return my;
}());